module.exports = __webpack_public_path__ + "media/t_searchdemo.527c5c22.mp4";